import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useRef, useState } from 'react';
import { useCopyToClipboard } from 'usehooks-ts';
interface UseCopyToClipboardProps {
  resetDelay?: number;
}
export function useCopyButton(t0) {
  const $ = _c(17);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    resetDelay: t2
  } = t1;
  const resetDelay = t2 === undefined ? 2000 : t2;
  const [, copy] = useCopyToClipboard();
  const [isCopied, setIsCopied] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [error, setError] = useState(null);
  const previousHoverRef = useRef(false);
  let t3;
  if ($[2] !== copy) {
    t3 = async value => {
      ;
      try {
        await copy(value);
        setIsCopied(true);
        setError(null);
      } catch (t4) {
        const err = t4;
        setIsCopied(false);
        setError(err instanceof Error ? err : new Error("Failed to copy"));
      }
    };
    $[2] = copy;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const handleCopy = t3;
  let t4;
  if ($[4] !== isCopied) {
    t4 = hovered => {
      if (hovered && !previousHoverRef.current && isCopied) {
        setIsCopied(false);
      }
      previousHoverRef.current = hovered;
      setIsHovered(hovered);
    };
    $[4] = isCopied;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const handleSetHovered = t4;
  let t5;
  let t6;
  if ($[6] !== isCopied || $[7] !== isHovered || $[8] !== resetDelay) {
    t5 = () => {
      if (isCopied && !isHovered) {
        const timer = setTimeout(() => {
          setIsCopied(false);
        }, resetDelay);
        return () => {
          clearTimeout(timer);
        };
      }
    };
    t6 = [isCopied, isHovered, resetDelay];
    $[6] = isCopied;
    $[7] = isHovered;
    $[8] = resetDelay;
    $[9] = t5;
    $[10] = t6;
  } else {
    t5 = $[9];
    t6 = $[10];
  }
  useEffect(t5, t6);
  let t7;
  if ($[11] !== error || $[12] !== handleCopy || $[13] !== handleSetHovered || $[14] !== isCopied || $[15] !== isHovered) {
    t7 = {
      isCopied,
      error,
      handleCopy,
      setIsHovered: handleSetHovered,
      isHovered
    };
    $[11] = error;
    $[12] = handleCopy;
    $[13] = handleSetHovered;
    $[14] = isCopied;
    $[15] = isHovered;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}